import React from 'react'
import Headers from '../../../components/Headers'
import {
  Input,
  Row,
  Col,
  Button,
  Table,
  Modal,
  Select,
  Drawer,
  message,
  Icon,
  Tabs,
} from 'antd'
import NProgress from 'nprogress'
import {
  fetchRecommendList,
  fetchGoodsList,
  fetchAddGoods,
  fetchDeleteGoods,
  fetchSortGoods,
} from '../../../api/recommendGoods'
import { DndProvider, DragSource, DropTarget } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import update from 'immutability-helper'
import Zhuanqu_goods from './Zhuanqu_goods'
import './index.scss'
const { TabPane } = Tabs
const BreadCrumbData = [
  { path: '/page/ssry/userInfo', name: '试试如意' },
  { path: '/page/ssry/userInfo', name: '用户信息' },
]

const { Column } = Table
const { Option } = Select

let dragingIndex = -1

class BodyRow extends React.Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props
    const style = { ...restProps.style, cursor: 'move' }

    let { className } = restProps
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward'
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward'
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />
      )
    )
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index
    return {
      index: props.index,
    }
  },
}

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex)

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex
  },
}

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, (connect) => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow)
)

class RecommendGoods extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      brandName: '',
      goodsName: '',
    },
    list: [],
    total: 0,
    bigImgUrl: '',
    bigImgVisible: false,
    goods_listQuery: {
      pageNum: 1,
      pageSize: 20,
      brandName: '',
      goodsName: '',
    },
    goods_list: [],
    goods_total: 0,
    addGoodsVisible: false,
    deletevisible: false,
    currentGoods: {},
  }
  components = {
    body: {
      row: DragableBodyRow,
    },
  }

  moveRow = (dragIndex, hoverIndex) => {
    const { list } = this.state
    const dragRow = list[dragIndex]
    console.log(list[dragIndex], list[hoverIndex])
    fetchSortGoods({
      materialsId: list[dragIndex].materialsId,
      recommendIndex: list[hoverIndex].recommendIndex,
    }).then((res) => {
      if (res.success) {
        this.setState(
          update(this.state, {
            list: {
              $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, dragRow],
              ],
            },
          })
        )
      }
    })
  }
  componentDidMount() {
    NProgress.start()
    this.getList()
    NProgress.done()
  }
  getGoodsList = () => {
    fetchGoodsList(this.state.goods_listQuery).then((res) => {
      if (res.success) {
        this.setState({
          goods_list: res.data.list,
          goods_total: res.data.total,
        })
      }
    })
  }
  getList = () => {
    fetchRecommendList(this.state.listQuery).then((res) => {
      if (res.success) {
        this.setState({
          list: res.data.list,
          total: res.data.total,
        })
      }
    })
  }
  handleSearch = () => {
    this.setState(
      {
        listQuery: { ...this.state.listQuery, pageNum: 1 },
      },
      () => {
        this.getList()
      }
    )
  }
  inputChange = (e) => {
    this.setState({
      listQuery: { ...this.state.listQuery, [e.target.name]: e.target.value },
    })
  }
  handleSearch1 = () => {
    this.setState(
      {
        goods_listQuery: { ...this.state.goods_listQuery, pageNum: 1 },
      },
      () => {
        this.getGoodsList()
      }
    )
  }
  inputChange1 = (e) => {
    this.setState({
      goods_listQuery: {
        ...this.state.goods_listQuery,
        [e.target.name]: e.target.value,
      },
    })
  }
  deleteGoods = (e) => {
    this.setState({
      currentGoods: e,
      deletevisible: true,
    })
  }
  handleAddGoods = () => {
    this.setState(
      {
        addGoodsVisible: true,
        goods_listQuery: {
          pageNum: 1,
          pageSize: 20,
          brandName: '',
          goodsName: '',
        },
      },
      () => {
        this.getGoodsList()
      }
    )
  }
  showBigImg = (url) => {
    this.setState({
      bigImgVisible: true,
      bigImgUrl: url,
    })
  }
  selectGoods = (e) => {
    const { goods_list, goods_listQuery } = this.state
    fetchAddGoods({ materialsId: e.materialsId }).then((res) => {
      if (res.success) {
        message.success('添加成功')
        this.getList()
        if (goods_list.length == 1) {
          this.setState(
            {
              goods_listQuery: {
                ...goods_listQuery,
                pageNum:
                  goods_listQuery.pageNum == 1
                    ? 1
                    : goods_listQuery.pageNum - 1,
              },
            },
            () => {
              this.getGoodsList()
            }
          )
        } else {
          this.getGoodsList()
        }
      }
    })
  }
  deleteOk = () => {
    const { listQuery, list, currentGoods } = this.state
    fetchDeleteGoods({ materialsId: currentGoods.materialsId }).then((res) => {
      if (res.success) {
        message.success('删除成功')
        if (list.length == 1) {
          this.setState(
            {
              listQuery: {
                ...listQuery,
                pageNum: listQuery.pageNum == 1 ? 1 : listQuery.pageNum - 1,
              },
            },
            () => {
              this.getList()
            }
          )
        } else {
          this.getList()
        }
        this.deleteCancel()
      }
    })
  }
  deleteCancel = () => {
    this.setState({
      deletevisible: false,
    })
  }
  render() {
    const {
      listQuery,
      list,
      total,
      goods_listQuery,
      goods_list,
      goods_total,
      addGoodsVisible,
      deletevisible,
    } = this.state
    return (
      <div className='container'>
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className='recommendGoods_container'>
          <Tabs size='large' defaultActiveKey='1'>
            <TabPane tab='橱窗商品' key='1'>
              <div className='tab_content'>
                <Row className='searchTop'>
                  <Col span={20}>
                    <Input
                      className='marginR'
                      style={{ width: 170 }}
                      name='goodsName'
                      onChange={this.inputChange}
                      value={listQuery.goodsName}
                      placeholder='商品名称'
                      allowClear
                    />

                    <Button onClick={this.handleSearch} type='primary'>
                      搜索
                    </Button>
                  </Col>
                  <Col span={4}>
                    <Button
                      onClick={this.handleAddGoods}
                      className='fr'
                      type='primary'>
                      添加商品
                    </Button>
                  </Col>
                </Row>
                <div className='content'>
                  <DndProvider backend={HTML5Backend}>
                    <Table
                      rowKey='materialsId'
                      dataSource={list}
                      components={this.components}
                      onRow={(record, index) => ({
                        index,
                        moveRow: this.moveRow,
                      })}
                      locale={{ emptyText: '橱窗暂无商品' }}
                      pagination={{
                        showTotal: () => `共${total}条`,
                        total: total,
                        current: listQuery.pageNum,
                        pageSize: listQuery.pageSize,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['10', '20', '30', '40', '100'],
                        onChange: (page, pageSize) => {
                          this.setState(
                            {
                              listQuery: { ...listQuery, pageNum: page },
                            },
                            () => this.getList()
                          )
                        },
                        onShowSizeChange: (current, pageSize) => {
                          this.setState(
                            {
                              listQuery: { ...listQuery, pageSize, pageNum: 1 },
                            },
                            () => this.getList()
                          )
                        },
                      }}>
                      <Column
                        title='ID'
                        dataIndex='recommendIndex'
                        key='recommendIndex'
                        render={(text, record, index) =>
                          index +
                          1 +
                          (listQuery.pageNum - 1) * listQuery.pageSize
                        }
                      />
                      <Column title='商品名称' dataIndex='name' key='name' />
                      <Column
                        title='品牌'
                        dataIndex='brandName'
                        key='brandName'
                      />
                      <Column title='售价' dataIndex='price' key='price' />
                      <Column
                        title='商品图片'
                        dataIndex='pic'
                        key='pic'
                        render={(text) => (
                          <img
                            onClick={() => this.showBigImg(text)}
                            style={{ width: 40, height: 40, cursor: 'pointer' }}
                            src={text}></img>
                        )}
                      />
                      <Column
                        title='操作'
                        render={(record) => {
                          return (
                            <React.Fragment>
                              <a className='marginR'>拖拽排序</a>
                              <a onClick={() => this.deleteGoods(record)}>
                                删除
                              </a>
                            </React.Fragment>
                          )
                        }}
                      />
                    </Table>
                  </DndProvider>
                </div>
              </div>
            </TabPane>
            <TabPane tab='专区商品' key='2'>
              <Zhuanqu_goods></Zhuanqu_goods>
            </TabPane>
          </Tabs>
        </div>
        <Modal
          title='图片预览'
          onCancel={() => this.setState({ bigImgVisible: false })}
          visible={this.state.bigImgVisible}
          footer={null}>
          <img
            style={{ width: '100%', height: '100%' }}
            src={this.state.bigImgUrl}></img>
        </Modal>
        <Drawer
          title='添加商品'
          width='640px'
          placement='right'
          closable={false}
          onClose={() =>
            this.setState({
              addGoodsVisible: false,
            })
          }
          visible={addGoodsVisible}>
          <div style={{ marginBottom: 16 }}>
            <Input
              className='marginR'
              style={{ width: 170 }}
              name='goodsName'
              onChange={this.inputChange1}
              value={goods_listQuery.goodsName}
              placeholder='商品名称'
              allowClear
            />
            <Input
              className='marginR'
              style={{ width: 170 }}
              name='brandName'
              onChange={this.inputChange1}
              value={goods_listQuery.brandName}
              placeholder='品牌'
              allowClear
            />
            <Button onClick={this.handleSearch1} type='primary'>
              搜索
            </Button>
          </div>
          <Table
            rowSelection={{
              type: 'radio',
              onSelect: this.selectGoods,
            }}
            rowKey='materialsId'
            dataSource={goods_list}
            pagination={{
              showTotal: () => `共${goods_total}条`,
              total: goods_total,
              current: goods_listQuery.pageNum,
              pageSize: goods_listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ['10', '20', '30', '40', '100'],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    goods_listQuery: { ...goods_listQuery, pageNum: page },
                  },
                  () => this.getGoodsList()
                )
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    goods_listQuery: {
                      ...goods_listQuery,
                      pageSize,
                      pageNum: 1,
                    },
                  },
                  () => this.getGoodsList()
                )
              },
            }}>
            <Column title='商品名称' dataIndex='name' key='name' />
            <Column title='品牌' dataIndex='brandName' key='brandName' />
            <Column title='售价' dataIndex='price' key='price' />
            <Column
              title='商品图片'
              dataIndex='pic'
              key='pic'
              render={(text) => (
                <img
                  onClick={() => this.showBigImg(text)}
                  style={{ width: 40, height: 40, cursor: 'pointer' }}
                  src={text}></img>
              )}
            />
          </Table>
        </Drawer>
        <Modal
          className='deleteGoods'
          title='删除商品'
          width={600}
          visible={deletevisible}
          onOk={this.deleteOk}
          onCancel={this.deleteCancel}>
          <Icon className='gantanhao' type='info-circle' theme='filled' />{' '}
          确定删除该商品？删除后将不再推荐区展示。
        </Modal>
      </div>
    )
  }
}
export default RecommendGoods
